(() => {
  function placeCompactRecommendations() {
    const target = document.querySelector('product-info.product-meta__wrapper');
    const upsell = document.querySelector('[data-fd-compact-upsell]');
    if (!target || !upsell || target.contains(upsell)) return;
    target.append(upsell);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeCompactRecommendations, {once:true});
  else placeCompactRecommendations();
  document.addEventListener('shopify:section:load', placeCompactRecommendations);
})();
